import React, { useState } from "react";

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <section id="contact" className="section bg-gradient-brand">
      <div className="container">
        <div className="row g-5 align-items-start">
          <div className="col-lg-12">
            <div className="eyebrow mb-3" style={{ color: "#5fe6cf" }}>
              Get in touch
            </div>
            <h2 className="display-font text-white mb-3" style={{ fontSize: "2.2rem", fontWeight: 600 }}>
              Tell us what's not talking to what
            </h2>
            <p style={{ color: "rgba(255,255,255,0.7)", lineHeight: 1.7 }}>
              Send a short description of the systems involved and what
              you're trying to achieve. We reply within one business day.
            </p>
            <div className="mt-5 pt-3" style={{ borderTop: "1px solid rgba(255,255,255,0.15)" }}>
              <div className="mono-label mb-2" style={{ color: "rgba(255,255,255,0.6)" }}>Email</div>
              <a href="mailto:contact@gapnix.net" className="d-block mb-4 text-white" style={{ fontSize: "1rem" }}>
                contact@gapnix.net
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const inputStyle = {
  borderRadius: "var(--radius-sm)",
  border: "1px solid #d8e3e2",
  padding: "0.7rem 1rem",
};
